import React, { useState } from "react";
import PhoneIcon from "../../../icons/PhoneIcon";
import { Button } from "./../ui/button";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import ContactAuthorizedOfficerCard from "./ContactAuthorizedOfficerCard";
import LoginModal from "../../../components/web/Auth/LoginModal";
import RegisterModal from "../../../components/web/Auth/RegisterModal";
import { useSelector } from "react-redux";
interface ContactButtonProps {
  allowRedirect?: boolean;
  listingId?: string;
  onClickHandler?: any;
  propertyData: any;
  setAuthModelOpen: any;
  setAcknowledgementOpen: any;
  setAcknowledgementDetails: any;
}

export default function ContactButton({
  onClickHandler,
  propertyData,
  allowRedirect,
  listingId,
  setAuthModelOpen,
  setAcknowledgementOpen,
  setAcknowledgementDetails,
}: ContactButtonProps) {
  const newPropertyData = { ...propertyData };
  if (!propertyData?.state) {
    newPropertyData["state"] = {
      name: propertyData?.dump?.location?.state_name,
    };
  }
  if (!propertyData?.asset)
    newPropertyData["asset"] = {
      name: propertyData?.dump.asset?.asset_type_name,
    };
  if (!propertyData?.city) {
    newPropertyData["city"] = {
      name: propertyData?.dump?.location?.district_name,
    };
  }
  if (!propertyData?.sub_asset_type) {
    newPropertyData["sub_asset_type"] = {
      name: propertyData?.dump.asset?.sub_asset_type_name,
    };
  }
  const userToken = useSelector((state: any) => state.auth.accessToken);
  const [open, setOpen] = useState(false);
  const clickHandler = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (userToken) {
      setOpen(true);
    } else {
      setAuthModelOpen(true);
    }
  };

  return (
    <div>
      <Button className="px-[37px] lg:px-12" onClick={clickHandler}>
        <div className="lg:hidden">
          <PhoneIcon />
        </div>
        <div className=" hidden lg:block">
          <PhoneIcon width={16} height={16} />
        </div>
        <p className="ml-[5px] font-openSans font-semibold text-xs lg:text-base text-brand-textWhite">
          Contact
        </p>
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[400px] rounded-lg">
          <DialogTitle className="hidden"> </DialogTitle>
          <DialogDescription className="hidden"></DialogDescription>
          <ContactAuthorizedOfficerCard
            allowRedirect={allowRedirect}
            listingId={listingId}
            propertyData={newPropertyData}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
            setOpen={setOpen}
            cardType="contactOfficer"
            formTitle="Enter detail"
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
